function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1104 917",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M907 539.056a9 9 0 0 0-9-9 9 9 0 0 0-9 9v600.004a9 9 0 0 0 18 0V539.056z",
    style: {
      fill: "#2b254e",
      fillRule: "nonzero"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m552 567.055-7.5 35-46 12-81.5 23 28-35-45.5 9 40-23.426-35-.074-36.5-23.5 43.5 3.074 61 7.426-61-37.5 140.5 30zm734 27 140.5-30c-21.67 15.049-32.5 22.574-32.5 22.574l38 7.426 40 27-40-10.926-51.5-.074 58 28-64-17 46.5 43-74.5-35h-53l-7.5-35zm-374.984-283.02-1.188-28.028-10.998-21.558 28.912 20.336-1.59-25.689L893.106 232l13.225 2.523 27.075 16.13 8.124 26.192 7.146-39.347 6.201 31.903 16.184-21.916-10.768 41.446 21.207-24.376-18.5 50.5-51.984-4.02zM783.338 896.872l26.378 17.582-5.81 46.837-8.855 83.509-8.14-11.96-3.5-31-33.5 43 14.337-54.352-21.337 42.352-19 23 6.5-28.5 19.5-48.997-19.5 31.997-19.935 9.53 72.862-122.998zm135.01 22.009 30.665 8.036 9.755 46.177 18.815 81.846-12.083-10.31-11.76-27.39-1.148.87-.092 58.02-6.5-12.5-11.5-75.501H933l-4 56.501-7 35.5h-2l-4.5-35.5v-31l-8.5 24.5-17.5 20.77 28.848-140.019zM898 529.629l-52.5 134.5H973l-37.5-124.5-37.5-10z",
    style: {
      fill: "#ffd25b"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m779.5 835.056-21.428 56.041A85.09 85.09 0 0 0 755 942.129c3.667 5.333 11.833 9 24.5 11s21.852 2.051 27.555.154l6.964-7.546a99.996 99.996 0 0 0 20.35-33.261l55.848-151.653 7.783-.194v145.168a87.265 87.265 0 0 0 13.564 46.727c7.291 2.403 15.769 3.605 25.436 3.605s16.167-1.833 19.5-5.5a83.2 83.2 0 0 0 19.214-44.899L990 772.056l-17-107.927c-10.222-2.667-22.722-4-37.5-4-14.778 0-44.778-1.858-90-5.573l-66 180.5z",
    style: {
      fill: "#ff6d5b",
      fillRule: "nonzero"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m848.666 874.146-35.166 7.483 36.736-37.441-10.263-62.123 37.401 21.988-28.708 70.093z",
    style: {
      fill: "#ffd25b"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970 538.556c27.333 19.333 55.17 33 83.5 41s110.17 8 245.5 0v84.573l-174.94 6.428c-10.31.379-20.62-.84-30.56-3.613L990 638.056l63.5 181-22.79 2.691-12.21-11.618-5 11.5-30.251 5.722L973 810.129l-10.342 19.653L918 835.056l11-292.5 41-4zm-107.5-8.5 38 6.5-104 298.5-43.5-9.427-4-12.5-11.69 9.214-10.31-2.214v-22l-19.385 19.126L683 813.056l113.5-204.5c-35.333 15.049-61.333 22.573-78 22.573h-179v-78.573c117.667-6.667 190.167-10 217.5-10s62.5-4.167 105.5-12.5z",
    style: {
      fill: "#2b254e"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299 579.556h87.75c4 0 7.25 3.246 7.25 7.25s-3.25 7.25-7.25 7.25H1299v-14.5zm-846.75 0H540v14.5h-87.75a7.25 7.25 0 0 1 0-14.5z",
    style: {
      fill: "#847daa"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m955.145 563.555 10.287 159.517.068-.017 1.5 16.074-5.5-.074v-14.559l-9.338.859 1.338 14.274H948v-13.891l-8.82.811 1.32 14.08H935v-13.696l-9 .828v13.868h-4.5l.486-14.101-3.757-163.973H892.5c-1.5 0-20.5-37 49.5-31.5 24.571 1.931 36.71-3.594 44 0 4.861 2.396 5.694 9.063 2.5 20-11.666 7.667-21.666 11.5-30 11.5h-3.355z",
    style: {
      fill: "#60588e"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.5 433.129c4.514 19.856 17.514 35.331 39 46.427 21.486 11.095 54.486 19.595 99 25.5l132.82.065 23.04-10.176 12.8-5.651a91.001 91.001 0 0 0 36.26-28.948l4.58-6.155c-.82-4.541-13.65-11.895-38.5-22.062-24.85-10.166-57.21-20.972-97.086-32.416-15.994-10.805-39.703-13.394-71.128-7.767-28.31 5.069-71.894 5.029-124.286 26.183-3.843 1.552-9.343 6.552-16.5 15z",
    style: {
      fill: "#2b254e"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.5 524.056c-6 1.333-9 6.166-9 14.5 0 8.333 17 16.691 51 25.073 4.224-6.157 8.391-10.49 12.5-13s11.442-5.201 22-8.073l-76.5-18.5z",
    style: {
      fill: "#847daa"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.798 540.562c22.241 2.337 31.183 3.861 60.154.456 7.501-.881 9.016-5.014 15.549-7.89 4.162-1.832 9.5-4.5 13-5.5 24.259-6.93 27.689-36.961 30.339-62.132 3.79-36.081-35.252-73.566-64.339-89.368-16.356-8.885-14.707-3.122-36.848-5.449-15.305-1.609-3.34-6.273-17.152-2.551-41.706 11.239-92.5 36-100.5 71-5.855 25.612-1.5 63.5 27.5 78.5 1.724.892 9.509 4.393 13 6.5 3.337 2.015 3.884 5.138 5.5 6 15.338 8.193 33.387 8.289 53.797 10.434z",
    style: {
      fill: "#ff6d5b",
      fillRule: "nonzero"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m876.488 416.008 13.672 1.921a15.001 15.001 0 0 1 11.328 8.144c5.57 11.136 8.243 17.502 8.019 19.099-.224 1.594-4.388 5.91-12.492 12.948a14.998 14.998 0 0 1-11.923 3.529l-15.843-2.226a15.003 15.003 0 0 1-10.99-7.507c-4.281-7.619-6.265-12.544-5.952-14.774.318-2.256 3.792-7.49 10.423-15.703a14.998 14.998 0 0 1 13.758-5.431zm98.481 11.383 9.837.86a15.002 15.002 0 0 1 12.09 8.195c5.224 10.365 7.764 16.334 7.624 17.908-.14 1.561-3.54 5.926-10.204 13.094a15 15 0 0 1-12.292 4.728l-11.988-1.049a15 15 0 0 1-11.788-7.628c-3.877-6.942-5.721-11.498-5.531-13.668.194-2.218 2.991-7.454 8.392-15.709a14.997 14.997 0 0 1 13.86-6.731z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886 444.629a7 7 0 1 1 0-14 7 7 0 0 1 0 14zm94.819 11.182a7 7 0 1 1 0-14 7 7 0 0 1 0 14zm-45.185-20.273a1.999 1.999 0 0 1 3.83.508l5.206 40.045a2.001 2.001 0 0 1-2.212 2.245l-20.824-2.403a2 2 0 0 1-1.618-2.753l15.618-37.642zm-88.894 40.513 23.617.854 17.507 13.813 20.994-7.984 15.511 13.952 24.346-10.223 13.167 9.103 12.515-7.391 28.023 6.561-27.43 1.919-18.117 13.296-11.95-13.199-23.243 11.65-16.614-15.379-16.365 9.666-19.746-17.165-22.215-9.473z",
    style: {
      fill: "#2b254e"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m896.439 312.655-2.939 32.9 77.5 9.5 1.496-34.031a14 14 0 0 0-10.757-14.237c-13.632-3.232-24.343-5.289-32.133-6.17-6.211-.703-12.774-.939-19.688-.708a14 14 0 0 0-13.479 12.746z",
    style: {
      fill: "#60588e"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898 308.129c-20.333 43.333-49.333 72.642-87 87.926-24.872 10.093-42.567 15.925-51.804 25.707-2.928 3.101-5.493 6.89-7.696 11.367 8.818 2.773 15.318 4.607 19.5 5.5 51.5 11 89.832 4.913 113 .5 11.06-2.107 27.84-6.19 50.341-12.249a99.998 99.998 0 0 1 39.52-2.521c55.059 7.512 88.779 13.269 101.139 17.27 13.82 4.472 21.71 8.948 23.68 13.426 1.48-10.358-2.22-18.496-11.09-24.415-4.32-2.883-29.55-8.572-48.09-20.585-10.1-6.546-24.22-19.047-42.344-37.502a82.997 82.997 0 0 1-21.73-39.811L972 317.629l-74-9.5z",
    style: {
      fill: "#60588e",
      fillRule: "nonzero"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m852.5 371.129 32-21 13.5 31.5 16-31.5 30-4-30-13.5-20.5-21-41 59.5z",
    style: {
      fill: "#2b254e",
      fillRule: "nonzero"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m906 325.129-21.5 51.5 13.5 12.5 60.5-42.5-52.5-21.5z",
    style: {
      fill: "#ffd25b"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 349.629c22.644 0 41-18.356 41-41s-18.356-41-41-41-41 18.356-41 41 18.356 41 41 41z",
    style: {
      fill: "#ebeef6",
      fillRule: "nonzero"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m633 417.629-7 21.5h-25l25 6.5 4 26.5 5-24 21.5-5-21.5-4-2-21.5zM1146 308.629l-7 21.5h-25s8.33 2.167 25 6.5c2.67 17.667 4 26.5 4 26.5s1.67-8 5-24l21.5-5-21.5-4-2-21.5zM1193.22 502.629l-5.3 16.174H1169l18.92 4.89 3.03 19.936 3.78-18.055 16.27-3.762-16.27-3.009-1.51-16.174zM736.333 306.129l-4.666 14.202H715l16.667 4.293 2.666 17.505 3.334-15.853L752 322.973l-14.333-2.642-1.334-14.202z",
    style: {
      fill: "#ffd25b"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.713 746.712a.65.65 0 0 1 0 .108c-.199 2.268-12.127 4.241-26.803 2.955-14.675-1.287-26.108-4.102-25.909-6.371a.739.739 0 0 1 .127-.348L586 723.628l-.186-18.805 2.288-23.561 51.579 4.46-7.114 19.807 2.225 41.188-.079-.005zm634.617 36.833c.01.033.02.068.02.104.4 2.242-10.61 7.235-25.12 9.791-14.51 2.556-26.28 2.795-26.68.552a.846.846 0 0 1 .05-.41l-.1-16.954-8.43-20.876a26.964 26.964 0 0 1-1.96-10.648l.25-12.716 50.98-9.041c2.26 6.618 3.65 12.378 4.16 17.281.51 4.903.51 12.403 0 22.5l6.9 20.401-.07.016zm-106.58-6.256v.108c-.16 2.271-12.05 4.452-26.75 3.422-14.69-1.03-26.17-3.646-26.01-5.917.01-.117.04-.23.11-.341l2.9-17.933.13-20.369 1.87-23.597 51.65 3.56-7.15 34.906 3.33 26.165-.08-.004z",
    style: {
      fill: "#847daa"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.549 687.78c-14.056-1.232-25.29-4.069-25.091-6.338.198-2.268 11.752-3.108 25.808-1.876 14.055 1.232 25.289 4.069 25.091 6.338-.199 2.268-11.753 3.108-25.808 1.876zm620.081 44.319c-13.9 2.447-25.48 2.614-25.88.371-.39-2.242 10.55-6.044 24.45-8.492 13.89-2.448 25.48-2.614 25.87-.372.4 2.243-10.54 6.045-24.44 8.493zm-93.07-13.363c-14.08-.987-25.36-3.628-25.2-5.9.16-2.271 11.7-3.313 25.77-2.326 14.08.986 25.36 3.628 25.2 5.899-.16 2.272-11.7 3.313-25.77 2.327z",
    style: {
      fill: "#60588e"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m625.864 723.461-.527 6.016-5.689-.497-.395 4.512-7.316-.641.395-4.511-20.077-1.757.526-6.016 21.58-15.421 7.316.641-1.503 17.177 5.69.497zm-25.24-.951 11.91 1.042.923-10.555-12.833 9.513zM1138 764.628c-10.85 0-16-4.977-16-14.038 0-9.023 5.15-13.962 16-13.962 10.81 0 16 4.978 16 13.962 0 9.022-5.19 14.038-16 14.038zm0-5c6.18 0 9-3.212 9-8.54 0-5.287-2.82-8.46-9-8.46s-9 3.132-9 8.46c0 5.368 2.82 8.54 9 8.54z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.038-.19.17-.206c.005.034.016.06.035.078a.095.095 0 0 0 .067.026c.028 0 .052-.01.072-.032a.125.125 0 0 0 .029-.087.12.12 0 0 0-.028-.082.09.09 0 0 0-.068-.03.227.227 0 0 0-.063.01l.015-.112c.037.001.065-.007.085-.024a.088.088 0 0 0 .029-.068.077.077 0 0 0-.021-.057.077.077 0 0 0-.057-.022.081.081 0 0 0-.06.024.117.117 0 0 0-.031.072L.048-.532a.274.274 0 0 1 .04-.103.175.175 0 0 1 .074-.062.262.262 0 0 1 .107-.022c.067 0 .121.022.162.065a.17.17 0 0 1 .05.119c0 .063-.034.113-.103.15a.168.168 0 0 1 .135.17.215.215 0 0 1-.069.161.238.238 0 0 1-.171.066.23.23 0 0 1-.161-.056.214.214 0 0 1-.074-.146z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "matrix(55.95337 -6.50568 4.86743 41.86315 857.764 549.174)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m622.954 614.742 4.211.881-9.498 67.376a2.013 2.013 0 0 1-2.405 1.69 2.299 2.299 0 0 1-1.806-2.571l9.498-67.376zm524.386 30.89 4.23.807-8.33 67.532a2.007 2.007 0 0 1-2.37 1.731 2.295 2.295 0 0 1-1.85-2.538l8.32-67.532zm70 14.051 4.27-.538 12.96 66.798a2.013 2.013 0 0 1-1.73 2.381 2.295 2.295 0 0 1-2.54-1.843l-12.96-66.798z",
    style: {
      fill: "#2b254e"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 334.129c1.918 0 3.402-.576 4.5-2 .8-1.037 1.5-2.72 1.5-4 0-1.613-.293-3.362-1.5-4.5-1.066-1.005-2.946-1.5-4.5-1.5-1.583 0-3.428.463-4.5 1.5-1.173 1.134-1.5 2.913-1.5 4.5 0 3.037 2.686 6 6 6zM553 302.629c2.876 0 5.102-.863 6.75-3 1.2-1.556 2.25-4.08 2.25-6 0-2.42-.44-5.043-2.25-6.75-1.598-1.508-4.419-2.25-6.75-2.25-2.374 0-5.142.695-6.75 2.25-1.759 1.701-2.25 4.37-2.25 6.75 0 4.556 4.029 9 9 9z",
    style: {
      fill: "#c1c6d3"
    },
    transform: "translate(-368 -232)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M565.884 318.945c1.22-.762 1.935-1.718 2.068-3.06.096-.978-.127-2.327-.636-3.141-.641-1.026-1.523-2.021-2.743-2.266-1.077-.216-2.47.217-3.458.835-1.007.629-1.996 1.657-2.266 2.742-.295 1.188.204 2.449.834 3.458 1.208 1.932 4.094 2.749 6.201 1.432z",
    style: {
      fill: "#c1c6d3"
    },
    transform: "translate(-368 -232)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError403);
export default __webpack_public_path__ + "static/media/error-403.fddbe0216e286f965ef0ea92dfabe16d.svg";
export { ForwardRef as ReactComponent };